import { render, staticRenderFns } from "./AccordionTease.vue?vue&type=template&id=206cbc24&lang=pug&"
import script from "./AccordionTease.vue?vue&type=script&lang=js&"
export * from "./AccordionTease.vue?vue&type=script&lang=js&"
import style0 from "./AccordionTease.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206cbc24')) {
      api.createRecord('206cbc24', component.options)
    } else {
      api.reload('206cbc24', component.options)
    }
    module.hot.accept("./AccordionTease.vue?vue&type=template&id=206cbc24&lang=pug&", function () {
      api.rerender('206cbc24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/AccordionTease.vue"
export default component.exports